/** Verse object property for Indo-Pak Arabic (API / Redux script value is `textIndopak`). */
export const VERSE_ARABIC_KEY_INDOPAK = 'textIndopak';

/** `font-family` name matching @font-face in fonts.css (verse numbers, inline styles). */
export function arabicFontFamilyCss(scriptStyle) {
  if (scriptStyle === 'textIndopak') return 'indopak_script_font';
  if (scriptStyle === 'textUthmani') return 'uthmani_script_font';
  return 'simple_script_font';
}

/** Ayah-end marker (﴾﴿ + digits): always `simple_script_font`, not the body script face. */
export const VERSE_END_MARKER_FONT_FAMILY = 'simple_script_font';

/** Word-level Arabic: Indo-Pak uses mushaf webfont only (not Khebrat / AllQalam). */
export function verseArabicWordClassName(scriptStyle) {
  return scriptStyle === 'textIndopak' ? 'verse-arabic-indopak' : 'Khebrat_Musamim_Bold';
}

/**
 * Raw Arabic string for the selected script from a verse object.
 * Indo-Pak always uses the `textIndopak` property on the verse.
 */
export function getVerseArabicText(scriptStyle, verse) {
  if (!verse) return undefined;
  if (scriptStyle === 'textIndopak') {
    return verse.textIndopak ?? verse.text_indopak ?? verse[VERSE_ARABIC_KEY_INDOPAK];
  }
  return verse[scriptStyle];
}

/** Invisible / bidi marks often trail API Arabic; strip from end before Indo-Pak cleanup. */
const TRAIL_MARKS_END = /[\u200C\u200D\u200E\u200F\u202A-\u202E\uFEFF\s]+$/g;

/**
 * Mushaf fonts map ayah-end "قف" etc. to a private-use codepoint (e.g. U+F500).
 * Remove only that trailing PUA glyph; keep Quranic marks before it (e.g. ۟ ۙ).
 */
function stripTrailingUnknownIndopakGlyph(s) {
  return s.replace(
    /[\uE000-\uF8FF](?:[\u200C\u200D\u200E\u200F\u202A-\u202E\uFEFF\u0610-\u061A\u064B-\u065F\u06D6-\u06ED\s]*)$/,
    '',
  );
}

/**
 * Indo-Pak: normalize fullwidth `_`, trim, strip bidi, drop trailing PUA ornament only,
 * then turn remaining `_` into spaces.
 */
function normalizeIndopakUnderscores(raw) {
  let s = String(raw).replace(/\uFF3F/g, '_');
  s = s.trim();
  s = s.replace(TRAIL_MARKS_END, '');
  s = stripTrailingUnknownIndopakGlyph(s);
  return s.replace(/_/g, ' ').replace(/\s+/g, ' ').trim();
}

/**
 * Arabic text for the selected script. Indo-Pak payloads may use underscores
 * where spaces belong for display and word-by-word alignment.
 */
export function verseTextForScript(scriptStyle, text) {
  if (text == null || text === '') return text;
  if (scriptStyle === 'textIndopak') {
    return normalizeIndopakUnderscores(text);
  }
  return text;
}

/** Normalized Arabic for UI: correct verse key per script, then Indo-Pak underscore → space. */
export function verseArabicForDisplay(scriptStyle, verse) {
  return verseTextForScript(scriptStyle, getVerseArabicText(scriptStyle, verse));
}

/** Word-by-word translation array for hover / search popup; Indo-Pak uses its own alignment when present. */
export function verseWordByWordTranslationForScript(scriptStyle, verse) {
  if (!verse) return null;
  if (scriptStyle === 'textIndopak') {
    return verse.versewordbywordTranslationIndopak ?? null;
  }
  return verse.versewordbywordTranslation;
}
